import { AccountRole, address as parseSolanaAddress, getBase58Encoder } from '@solana/kit';

import type { DefinitiveSvmInstruction } from './schemas';

export function toSolanaInstruction(instruction: DefinitiveSvmInstruction) {
  return {
    programAddress: parseSolanaAddress(instruction.programId),
    accounts: instruction.accounts.map((account) => ({
      address: parseSolanaAddress(account.pubkey),
      role: account.isSigner
        ? account.isWritable
          ? AccountRole.WRITABLE_SIGNER
          : AccountRole.READONLY_SIGNER
        : account.isWritable
          ? AccountRole.WRITABLE
          : AccountRole.READONLY,
    })),
    data: getBase58Encoder().encode(instruction.data),
  };
}
